const ORDER_TABLE_TYPES = {
  /* 全部, (檔案不合格), 待付款, 已完成, 月結*/
  NORMAL: 'NORMAL',
  ORDER_ITEM_REJECTED: 'ORDER_ITEM_REJECTED',
  WAITING_OR_PROCESSING: 'WAITING_OR_PROCESSING',
  SUCCESS: 'SUCCESS',
  MONTHLY: 'MONTHLY',
  CURRENT_MONTHLY: 'CURRENT_MONTHLY:',
  CREDIT_ORDER: 'CREDIT_ORDER', // type = 點數
  CREDIT_PAY: 'CREDIT_PAY', // 點數付款
  PERIOD: 'PERIOD',
};

export default ORDER_TABLE_TYPES;
